import { render, staticRenderFns } from "./BuyPopup.html?vue&type=template&id=ff3d6fac&scoped=true&external"
import script from "./BuyPopup.vue?vue&type=script&lang=js"
export * from "./BuyPopup.vue?vue&type=script&lang=js"
import style0 from "./BuyPopup.scss?vue&type=style&index=0&id=ff3d6fac&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3d6fac",
  null
  
)

export default component.exports